import React               from "react";
import { Box, Typography } from "@mui/material";
import { useTheme }        from "@mui/material/styles";
import { getCurrentYear }  from "../../../../../utils/date";

const LoginFooter = ({ onAdminClick }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>

      <Typography
        sx={{
          fontFamily:    "'Inter', 'Courier New', monospace",
          fontSize:      "8.5px",
          color:         t.text3,
          letterSpacing: "0.04em",
          textAlign:     "center",
          lineHeight:    2,
        }}
      >
        PSI360 Resource Allocation &nbsp;·&nbsp; v1.0 &nbsp;·&nbsp; {getCurrentYear()}
      </Typography>

      {/* Hidden admin access - barely visible */}
      <Typography
        onClick={onAdminClick}
        sx={{
          fontFamily:    "'Inter', 'Courier New', monospace",
          fontSize:      "7.5px",
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color:         t.border2,
          cursor:        "pointer",
          userSelect:    "none",
          transition:    "color 0.2s",
          "&:hover":     { color: t.text3 },
        }}
      >
        admin access
      </Typography>
    </Box>
  );
};

export default LoginFooter;